import { useContext } from 'react';
import { BreakpointsContext } from '../contexts/BreakpointsContext';

export default function useIsMobile() {
  return useContext(BreakpointsContext);
}
